import React, { Component } from 'react';
import Header from "../layout/header"
import Footer from "../layout/footer"
import Menu from "../layout/doctorLeftmenu"
import {Link} from "react-router-dom"; 
import $ from 'jquery';

import {db,database,insightRef} from '../firebase'
export default class NewInsights extends Component {
    constructor(props) {
        super(props)
        this.state = {
            insightTitle:'',
            titleShortDescription:'',
            description:"",
            


        }
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange = (event) => {
        const { value, name } = event.target;
        this.setState({
          [name]: value,
        });
      };

      componentDidMount(){
        const url = new URL(window.location.href);
        const searchParams3 = new URLSearchParams(url.search);
        let url_path = window.location.href.split("=");
        let keyId  = (url_path[1]);
        this.renderList(keyId)


      }



async  renderList(keyId){
  
  let dataList=[]
  let id =keyId;

let batchesRef = database.ref(); // parent key of "batch-1", "batch-2", etc.
                                            // assumed to be the database root here
                                            const ref = id ? '/insights/' + id : 'insights'
                                            const userRef = database.ref(ref)
                                          
                                            const valueRef = id ? userRef : await userRef.orderByChild('key').equalTo('value')
                                            const snapshot = await valueRef.once('value')
                                          
                                            const val = snapshot.val()
                                            if (val) {
                                              this.setState({insightTitle:"2222"})
                                              $("#insightTitle").val(val.insightTitle)
                                              $("#description").val(val.description)
                                              $("#titleShortDescription").val(val.titleShortDescription)

                                              // dataList.push({key:id,insightTitle:val.insightTitle,
                                              //              description:val.description,
                                              //              titleShortDescription:val.titleShortDescription
                                              //            } )    
                                            }

 
}



    saveInsights(){
        if(this.state.insightTitle===''){
            alert('Enter Title')
        }
        else if(this.state.titleShortDescription===''){
            alert('Enter title short description')
        }
        else if(this.state.description===''){
            alert('Enter description')
        }
        else{
         const item={
            insightTitle:this.state.insightTitle,
            titleShortDescription: this.state.titleShortDescription,
            description: this.state.description
            }
         insightRef.push(item).then(()=>{
          alert("Saved Successfully")
          window.location.reload()
        }).catch(()=>{
          alert("Somthing went wrong")
        })
         console.log(insightRef)

         this.setState({description:'',titleShortDescription:'',insightTitle:''})
        }
    }
    render() {
       
    return (

      <div className="main-wrapper">
        <Header></Header>
        <div className="main-content">    
        <Menu></Menu>    
          <div className="content-right-wrapper">
            <div className="container">
              <form className='form-wrapper'>
                <div className='form-head'>Insights</div>
                <div className="form-group">
                  <label for="insightTitle">Title</label>
                  <input type="text" className="form-control" name="insightTitle" 
                  id="insightTitle" onChange={this.handleChange}
                  defaultValue={this.state.insightTitle}
                  />
                </div>
                <div className="form-group">
                  <label for="titleShortDescription">Title Short Description</label>
                  <textarea className="form-control" id="titleShortDescription" 
                  name="titleShortDescription" rows="3" onChange={this.handleChange} ></textarea>
                </div>
                <div className="form-group">
                  <label for="description"> Description</label>
                  <textarea className="form-control" id="description" name="description"
                   rows="3" onChange={this.handleChange}></textarea>
                </div>
                
                
                
                
                <div className="form-group mt-4">
                  <button type="button" className="btn btn-primary" onClick={() => this.saveInsights()}>Submit</button>
                </div>
              </form>
            </div>
            
          </div>
        </div>
        
        <Footer></Footer>
      </div>
      )
    }
}



// WEBPACK FOOTER //
// ./src/admin/newInsights.jsx